import { createFileRoute } from '@tanstack/react-router';
import { Outlet } from '@/lib/router-components';

export const Route = createFileRoute('/community/jobs')({
  component: JobsLayout,
});

function JobsLayout() {
  return <Outlet />;
}
